"use strict";

const _items = JSON.parse(localStorage.getItem('bls__-items'));
const Div = document.querySelector('.bls__-page-main');
var BlsPageShopify = (function() {
    return {
  
        initItems: function() {
            if (window.location.search.indexOf("page=") == -1) {
                this.init();
            }
        },
        
        init: function () {
            const _this = this;
            if (Div) {
                const div_no_product = Div.querySelector('.bls__-no-product-js');
                if (_items === null || _items.length === 0) {
                    _this.skeletonFunction(0)
                    div_no_product.classList.remove('d-none');
                }else{
                    var query = '';
                    _items.forEach((e, key, _items) => {
                        
                        if (!Object.is(_items.length - 1, key)) {
                        query += e+'%20OR%20handle:';
                        }
                        else{
                        query += e;
                        }
                    })

                    var productAjaxURL = "?view=&type=product&options[unavailable_products]=last&q=handle:"+query;

                    fetch(`${window.routes.search_url}${productAjaxURL}`)
                    .then(response => response.text())
                    .then((responseText) => {
                        const html = parser.parseFromString(responseText, 'text/html');
                        const row = document.createElement('div');
                        row.classList.add('row');
                        const exist_row = Div.querySelector('.row');
                        if (exist_row) {
                            exist_row.remove();
                        }
                        const er = html.querySelector(".bls__search-page-main > .row")
                        if(_items.length !== 0 && er){
                            Div.innerHTML = er.outerHTML;
                            _this.skeletonFunction(700)

                        }else{
                            _this.skeletonFunction(0)
                            div_no_product.classList.remove('d-none');
                        }
                        _this.mergeItems();
                    }).catch((e) => {
                        console.error(e);
                    }).finally(e => {
                        BlsColorSwatchesShopify.init();
                        BlsSubActionProduct.handleInitQuickviewAction();
                        BlsSubActionProduct.init();
                        BlsLazyloadImg.init();
                    })
                }
            }
        },
        mergeItems: function () {
            const arr = [];
            if (Div) {
                Div.querySelectorAll(".bls__product-item").forEach(e => {
                    arr.push(e?.dataset.productHandle);
                })
            }
            localStorage.setItem('bls__-items',JSON.stringify(arr));
        },
        skeletonFunction: function (timer) {
            window.setTimeout(function() {
                if (this.document.querySelector('skeleton-page')) {
                    this.document.querySelector('skeleton-page').remove();
                }
                if (this.document.querySelector('.bls__-page-section-inner')) {
                    this.document.querySelector('.bls__-page-section-inner').classList.remove('d-none');
                }
            },timer)
        }
      }
  })();
  BlsPageShopify.initItems();